export default {
    data() {
        return {
            processing: false
        }
    },
    methods: {
        startCall() {
            this.processing = true;
        },
        endCall() {
            this.processing = false;
        }
    }
}